import { useState, useEffect } from 'react';
import { ALLOWED_DOMAIN } from '../config';

const STORAGE_KEY = 'sm_user';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [authError, setAuthError] = useState(null);

  // Restore session from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        // Check if the stored session has an expiry and if it is still valid
        if (parsed.exp && Date.now() / 1000 > parsed.exp) {
          localStorage.removeItem(STORAGE_KEY);
          setAuthError('Your session expired. Please sign in again.');
        } else {
          setUser(parsed);
        }
      }
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  function onSuccess(cr) {
    try {
      const p = JSON.parse(atob(cr.credential.split('.')[1]));
      if (!p.email || !p.email.endsWith(ALLOWED_DOMAIN)) {
        setAuthError('Access restricted to ' + ALLOWED_DOMAIN + ' accounts.');
        setAuthError(null);
        return;
      }
      setAuthError(null);
      // Keep the raw ID token (cr.credential) — the server verifies it on the
      // PHI endpoint (/api/patients). It expires with the session (~1h, p.exp).
      const userData = { name: p.name, email: p.email, picture: p.picture, isAdmin: true, exp: p.exp, token: cr.credential };
      setUser(userData);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
    } catch { setAuthError('Login failed. Please try again.'); }
  }

  function onError() { setAuthError('Google sign-in failed. Please try again.'); }

  function signOut() {
    setUser(null);
    localStorage.removeItem(STORAGE_KEY);
  }

  return { user, authError, onSuccess, onError, signOut };
}
